export const DEFAULT_PAGE = 0; // UI page is 0-based
export const DEFAULT_PAGE_SIZE = 10;

export const toApiPage = (uiPage: number) => Math.max(uiPage, 0) + 1;

export const toUiPage = (apiPage: number) => Math.max((apiPage || 1) - 1, 0);

export const normalizePageSize = (value: number, fallback = DEFAULT_PAGE_SIZE) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
};

export const buildPaginationPayload = (page: number, limit: number) => ({
  page: toApiPage(page),
  limit: normalizePageSize(limit),
});
